import { useEffect } from "react";
import { isEqual } from "lodash";
import { Dispatch } from "redux";
import { setHomepageConfig } from "../redux/actions";
import { HomepageConfig } from "../utils/types";

export const useCacheConfig = (
  homepageConfig: HomepageConfig,
  homepageCachedConfig: HomepageConfig | null,
  dispatch: Dispatch
) => {
  useEffect(() => {
    if (
      !homepageCachedConfig ||
      !isEqual(homepageCachedConfig, homepageConfig)
    ) {
      dispatch(setHomepageConfig(homepageConfig));
    }
  }, [homepageConfig]);
};
